/* eslint-disable */
/* prettier-ignore-start */
// [GENERATED FILE; DO NOT EDIT BY HAND]

import React from "react"

var element = React.createElement("svg", {
  fill: "currentColor",
  viewBox: "0 0 6 4",
  "aria-hidden": "true"
}, React.createElement("path", {
  d: "M5.69 1.784l-1.94 1.91a1.072 1.072 0 01-1.5 0L.31 1.784a1.034 1.034 0 010-1.478C.51.11.78 0 1.06 0h3.88C5.524 0 6 .468 6 1.045c0 .277-.112.543-.31.739z"
}));

var Svg = React.forwardRef(function (props, ref) {
  var next = { ref: ref };
  for (var key in props) {
    if (props.hasOwnProperty(key)) {
      next[key] = props[key];
    }
  }
  return React.cloneElement(element, next);
});
Svg.displayName = "Caret";
Svg.element = element;
export default Svg;
